import styled from 'styled-components';

const Container = styled.div`
  margin-top: 25px;
`;

const ContainerChart = styled.div`
  width: 100%;
  position: relative;
`;

const Chart = styled.div`
  display: inline-block;
  width: 80%;
  height: 500px;
`;

const AverageText = styled.div`
  color: ${(props) => props.theme.color.text};
`;

const ContainerAverage = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  width: 15%;
  border: 1px solid ${(props) => props.theme.color.categorizingBorder};
  margin: 0 0 0 10px;
  border-radius: 3px;
  text-align: center;
  height: 60px;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const ChartContainer = styled.div`
  width: 100%;
  height: 500px;
`;

export {
  Container,
  ContainerChart,
  ContainerAverage,
  Chart,
  AverageText,
  ChartContainer,
};
